import styled from 'styled-components';

const Filler = styled.div`
  flex-grow: 1;
`;

export default Filler;
